module.exports = __webpack_public_path__ + "img/target003.3d3ecbf5.png";